module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._m(0), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, _vm._l((_vm.cardList), function(item, i) {
    return _c('el-col', {
      key: i,
      attrs: {
        "span": 8
      }
    }, [_c('div', {
      staticClass: "card",
      on: {
        "mouseover": function($event) {
          _vm.update(item)
        },
        "mouseout": function($event) {
          _vm.update(item)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.img
      }
    }), _vm._v(" "), _c('div', [_c('p', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.desc))]), _vm._v(" "), _c('p', {
      on: {
        "click": function($event) {
          _vm.fnToRouter('/404')
        }
      }
    }, [_vm._v(_vm._s(item.btn.name))])])])])
  }))], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('p', [_vm._v("QLink物联网方案特色")]), _vm._v(" "), _c('p', {
    staticClass: "sub"
  }, [_vm._v("设备端+云端+移动端，智能产品在这里无需开发")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-3dbdd9ec"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/modules/home/page_3.vue
// module id = 775
// module chunks = 1